import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import MuiSnackbar from '@mui/material/Snackbar'
import React from 'react'

export interface SnackbarProps {
  message: string | JSX.Element
  open?: boolean
  title?: string
  onClose?: () => void
  severity?: 'success' | 'info' | 'warning' | 'error'
  autoHideDuration?: number
}
export default function Snackbar(props: SnackbarProps): JSX.Element {
  const {
    message,
    severity,
    onClose,
    title,
    open = true,
    autoHideDuration = 6000,
  } = props

  return (
    <MuiSnackbar open={open} autoHideDuration={autoHideDuration} onClose={onClose}>
      <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
        {title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </Alert>
    </MuiSnackbar>
  )
}
